<div class="main-content cartItems pt-5 pb-5">
  <div class="container">
    <div class="breadcrumbs pt-5 pb-5">
      <span role="button" routerLink="/">Home</span>
      <img class="mx-3"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/chevron-right.svg'"
        alt="Cart | Luminous">
      <span>Cart</span>
    </div>
    <div *ngIf="cartInfo$.length == 0">
      <!--h2 class="mb-4">Cart Details</!--h2-->
      <h1 class="mb-4">Your Cart</h1>
      <h2>Cart items</h2>
      <div class="img-main text-center">
        <img loading="lazy" [src]="environment?.blobUrl+'/assets/images/saved-items/saved-product-img.svg'"
          alt="Cart checkout | Luminous">
        <p>Your cart is empty. Please add product to checkout.
        </p>
        <a href="" class="primaryBtn mt-5">Go to Home</a>
      </div>
    </div>
    <div class="row" *ngIf="cartInfo$.length != 0">
      <div class="col-lg-8 cartItemsMain">
        <div class="d-flex align-items-baseline cartItemsHeader mb-5 justify-content-between">
          <div>
            <h1 class="mb-4">Your Cart</h1>
            <!--h2>Cart Details</!--h2-->
            <h2>Cart items</h2>
          </div>

          <span *ngIf="cartInfo$" class="ms-5">{{cartInfo$.length || 0}} {{cartInfo$.length ===1?
            'item':'items'}}</span>
        </div>
        <div *ngIf="cartInfo$">
          <div class="cartItemsCard py-5" *ngFor="let product of cartInfo$; let i = index">
            <div class="img-wrap">
              <a [routerLink]="getPDPLink(product.productGuId,product.productName)">
                <img loading="lazy" role="button" [src]="product.productImageFileName" alt="PDP | Luminous">
              </a>
            </div>
            <div class="text-wrap ps-3">
              <a [routerLink]="getPDPLink(product.productGuId,product.productName)">
                <h4 role="button" class="mb-1 text-transform-none">
                  {{product.productName | truncateStr:[50]}}</h4>
              </a>
              <div class="pricing mb-3 d-flex">
                <p class=" me-3">Price</p>
                <span id="storePrice " class="me-3">₹ {{product.basePrice|
                  number:'1.2-2'}}</span>
                <span id="orignalPrice" class="text-decoration-line-through">₹ {{(product.productMRP*product.quantity) |
                  number:'1.2-2'}}</span>
              </div>
              <!-- <div class="pricing mb-3 d-flex" *ngIf="product.discount">
                <p class=" me-3">Discount</p>
                <span id="storePrice " class="me-3">₹ {{(product.discount*product.quantity)| number:'1.2-2'}}</span>
              </div> -->
              <div class="pricing mb-3 d-flex">
                <p class="me-3">Taxes</p>
                <span id="storePrice" class="me-3">₹ {{product.taxAmount| number:'1.2-2'
                  }}</span>
              </div>
              <div class="d-flex justify-content-between">
                <app-cart [product]="cartInfo$[i]"></app-cart>

              </div>
              <div class="total-price my-3">
                Total <span class="text-grey me-3">(Inclusive of all taxes)</span><span
                  class="bold">₹{{(product.basePrice + product.taxAmount)|
                  number:'1.2-2'}}</span>
              </div>
              <div class="total-tax d-flex justify-content-between">
                <div><span class=" me-3">Delivery By : {{product.deliverySLA | date: 'fullDate'}} </span>
                </div>
                <img id="delete" loading="lazy" [src]="environment?.blobUrl+'/assets/images/address-book/delete.svg'"
                  (click)="onProductDelete(product)" alt="Delete | Luminous">
              </div>
            </div>
          </div>
        </div>

        <div class="cartItemsPincode">
          <div class="d-flex mt-5 align-items-center inputPincode">
            <span>Pincode</span>
            <div class="d-flex align-items-center">
              <span type="text" class="me-3 ms-3">{{utils.getUserPicode()}}</span>
              <span class="ms-3" (click)="openLocationDialog()">
                Change
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 ps-lg-5" *ngIf="cartInfo$.length != 0">
        <app-order-summary [isCartPage]="true"></app-order-summary>
        <div class="btn-wrap">
          <a (click)="_location.back()" class="back-btn d-md-none">Back</a>
          <button (click)="proceedToCheckout()" class="primaryBtn w-100 text-center">Next</button>
        </div>
      </div>
    </div>
  </div>
</div>